export default __webpack_public_path__ + "static/media/auth-signup-blue-card.cae8da7b.svg";